/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type AutoChatReplyCopyConfirmationModalPlannerFragment = { id: string, name: string };

export const AutoChatReplyCopyConfirmationModalPlannerFragmentDoc = gql`
    fragment AutoChatReplyCopyConfirmationModalPlanner on Planner {
  id
  name
}
    `;